var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("fields-section"),
      _vm._v(" "),
      _c("todos-section"),
      _vm._v(" "),
      _c("users-section"),
      _vm._v(" "),
      _c("logo-section"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }